export const blockIconsPrivacyandsecurityShieldQuestionNew = (
	<span className='material-symbols-outlined'>shield_question</span>
);
